import { render, staticRenderFns } from "./modalBox.vue?vue&type=template&id=404062be&scoped=true"
import script from "./modalBox.vue?vue&type=script&lang=js"
export * from "./modalBox.vue?vue&type=script&lang=js"
import style0 from "./modalBox.vue?vue&type=style&index=0&id=404062be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404062be",
  null
  
)

export default component.exports